module.exports = require("./../../_gen/starling/display/Quad");


//////////////////
// WEBPACK FOOTER
// ./lib/starling/display/Quad.js
// module id = 171
// module chunks = 0